import { render, staticRenderFns } from "./BorrowerLoans.vue?vue&type=template&id=dadd4f52&scoped=true&"
import script from "./BorrowerLoans.vue?vue&type=script&lang=js&"
export * from "./BorrowerLoans.vue?vue&type=script&lang=js&"
import style0 from "./BorrowerLoans.vue?vue&type=style&index=0&id=dadd4f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd4f52",
  null
  
)

export default component.exports